export const serializerContentOps = (eventObj) => {
  const {
    addToCalendar,
    artists,
    artistTmUrl,
    buyBoxCallToActions,
    category,
    dataFields,
    dateTime,
    dbPostponedStatus,
    dbPublishStatus,
    defaultImage,
    eventDetails,
    sphereFlags,
    tourName,
    doNotOverrideRecommendations,
    doorOpenTime,
    enablePresale,
    endDate,
    eventType,
    externalHeroCta,
    flags,
    gallery,
    eventObjectId,
    genres,
    hostUrl,
    slug,
    htmlDescription,
    internalSearch,
    name,
    pageMeta,
    postponed,
    postponedText,
    publish,
    seriesId,
    specialGuest,
    pullDownFromSystem,
    relatedEvents,
    roxFlags,
    roxGroupFlags,
    searchDocumentId,
    spanMultipleDays,
    startTime,
    status,
    statusText,
    subCategory,
    subTitle,
    venue
  } = eventObj
  console.log(eventObj)
  return {
    ...(spanMultipleDays && { date_time: dateTime }),
    add_to_calendar: addToCalendar,
    artist_tm_url: artistTmUrl,
    artists,
    sphere_flags: sphereFlags,
    buy_box_call_to_actions: buyBoxCallToActions,
    category,
    enable_presale: enablePresale,
    data_fields: dataFields,
    dbPostponedStatus,
    dbPublishStatus,
    default_image: defaultImage,
    do_not_override_recommendations: doNotOverrideRecommendations,
    door_open_time: doorOpenTime,
    end_date: endDate,
    event_details: eventDetails,
    event_type: eventType,
    external_hero_cta: externalHeroCta,
    tour_name: tourName,
    flags,
    gallery,
    eventObjectId,
    slug,
    genres,
    host_url: hostUrl,
    html_description: htmlDescription,
    internal_search: internalSearch,
    name,
    page_meta: pageMeta,
    postponed_text: postponedText,
    postponed,
    publish,
    pull_down_from_system: pullDownFromSystem,
    related_events: relatedEvents,
    rox_flags: roxFlags,
    rox_group_flags: roxGroupFlags,
    spanMultipleDays,
    seriesId,
    special_guest: specialGuest,
    start_time: startTime,
    status_text: statusText,
    search_document_id: searchDocumentId,
    status,
    sub_category: subCategory,
    sub_title: subTitle,
    venue_id: venue && venue.length > 0 ? venue[0].id : null
  }
}
